import React from 'react';
import PropTypes from 'prop-types';

import { mergeClasses } from '@utils';

import './Heading.css';

export default function Heading({
  as: Component,
  children,
  className,
  ...restProps
}) {
  return (
    <Component
      className={mergeClasses(
        'm-0 text-black antialiased',
        {
          'text-[40px] font-extrabold uppercase tracking-[-1px] md:text-[56px]':
            Component === 'h1',
          'text-[32px] font-bold uppercase md:text-[40px]': Component === 'h2',
          'text-[24px] font-bold uppercase md:text-[32px]': Component === 'h3',
          'text-[24px] font-bold': Component === 'h4'
        },
        className
      )}
      {...restProps}
    >
      {children}
    </Component>
  );
}

Heading.propTypes = {
  as: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4']),
  children: PropTypes.string.isRequired,
  className: PropTypes.string
};

Heading.defaultProps = {
  as: 'h1',
  className: ''
};
